import { take } from "../util/takePayload";
export const fromGQL = (gqlItem) => take(gqlItem, 'firstName', 'lastName', 'email', 'phoneNumber');
//# sourceMappingURL=CheckoutCustomer.js.map